import React from 'react';
import { useNavigate } from 'react-router-dom'

import { Dropdown } from 'semantic-ui-react'

const Menu = () => {
    const navigate = useNavigate();

    const backHomeClick = () => {
        navigate('/')
    }

    return (
        <Dropdown text='Menu' className="melee-inline-dropdown">
            <Dropdown.Menu>
                <Dropdown.Item icon='home' text='Home' onClick={() => backHomeClick()} />
            </Dropdown.Menu>
        </Dropdown>
    )
}

export default Menu;